export const IMAGES = {
    cover: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=1920&q=80",
    hero: "https://images.unsplash.com/photo-1624138784614-87fd1b6528f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxzeWRuZXklMjBoYXJib3VyfGVufDB8fHx8MTc4ODMxNjg3NHww&ixlib=rb-4.1.0&q=85",
    polluted: "https://images.unsplash.com/photo-1759868414148-913f1cc34049?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxwb2xsdXRlZCUyMHJpdmVyJTIwcGxhc3RpY3xlbnwwfHx8fDE3ODgzMTY4NzV8MA&ixlib=rb-4.1.0&q=85",
    productDrone: "/images/product-drone.png",
    foreshore: "/images/parramatta-foreshore.jpg",
    truck: "/images/river-cleanup-truck.webp",
    rubbish: "/images/river-rubbish.webp",
    nielsen: "/images/harbour-beach-a.jpg",
    balmoralReal: "/images/balmoral-mosman.jpg",
    art: "https://images.unsplash.com/photo-1786033854388-a1c0dc159d8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxpbmRpZ2Vub3VzJTIwYWJvcmlnaW5hbCUyMGFydHxlbnwwfHx8fDE3ODgzMTY4NzV8MA&ixlib=rb-4.1.0&q=85",
    balmoral: "https://images.unsplash.com/photo-1551955682-78a3c53ab544?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGJlYWNoJTIwc3lkbmV5JTIwYmFsbW9yYWx8ZW58MHx8fHwxNzg4MzE2ODc1fDA&ixlib=rb-4.1.0&q=85",
    beach: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1600&q=80",
    wave: "https://images.unsplash.com/photo-1439405326854-014607f694d7?w=1920&q=80",
    opera: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1600&q=80",
    whale: "/images/whale-shark.png",
    prototype1: "/images/prototype-1.png",
    prototype2: "/images/prototype-2.png",
    beach1: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=1200&q=80",
    beach2: "https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?w=1200&q=80",
    beach3: "https://images.unsplash.com/photo-1520942702018-0862200e6873?w=1200&q=80",
};

export const ILLUSTRATIVE_BEACHES = [
    { src: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=1200&q=80", name: "Clear shallows" },
    { src: "https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?w=1200&q=80", name: "Calm foreshore" },
    { src: "https://images.unsplash.com/photo-1520942702018-0862200e6873?w=1200&q=80", name: "Open coastline" },
];

export const HERO_STATS = [
    { value: "750,000+", label: "Residents across the catchment, including many local Indigenous communities" },
    { value: "#9 of 120", label: "NSW waterways ranked for microplastics, Parramatta River" },
    { value: "66 m³", label: "Rubbish physically removed in 2024, roughly 440 bathtubs" },
    { value: "33", label: "Greater Sydney councils. Ten share the river itself." },
];

export const CRISIS_STATS = [
    {
        value: "#9",
        label: "Parramatta River",
        detail: "9th most microplastic-contaminated of 120 NSW coastal waterways tested, NSW EPA Broadscale Microplastic Assessment 2021–2024 (published March 2026).",
    },
    {
        value: "#4",
        label: "Toongabbie Creek",
        detail: "The river's upper-catchment hotspot is the 4th most contaminated waterway in New South Wales.",
    },
    {
        value: "31,966",
        label: "Particles identified",
        detail: "Microplastic particles identified statewide. Microplastics were detected in all 120 waterways tested.",
    },
    {
        value: "~74%",
        label: "Plastic by item count",
        detail: "Share of estuary litter that is plastic. NSW estuaries average 110 items and 8.20 L of litter per 1,000 m².",
    },
    {
        value: "~79%",
        label: "Litter from two sites",
        detail: "Meadowbank (Ryde), an official NSW EPA monitoring site, and Cooks River together account for roughly 79% of litter across 10 NSW sites.",
    },
    {
        value: "0.02–34.80",
        label: "Particles per m³",
        detail: "Microplastic concentration range measured across NSW waterways. The Parramatta River sits at the wrong end of it.",
    },
];

export const COMPARISON = [
    {
        metric: "Microplastics",
        parramatta: "Detected, ranked #9 most contaminated of 120 NSW waterways",
        harbour: "Detected in nearby tributary systems; Middle Harbour Creek is #10",
    },
    {
        metric: "Litter monitoring",
        parramatta: "Meadowbank (Ryde) is an official NSW EPA litter monitoring site",
        harbour: "No equivalent harbour site in the NSW KLIS program",
    },
    {
        metric: "Seafood safety",
        parramatta: "Elevated dioxins, NSW Health advises against eating seafood caught west of the Harbour Bridge",
        harbour: "Same advice; commercial fishing prohibited as a health precaution",
    },
    {
        metric: "Water-quality monitoring",
        parramatta: "Regular monitoring across the river and its catchment",
        harbour: "Major tributaries monitored; no comprehensive harbour-wide program",
    },
    {
        metric: "Rubbish physically removed",
        parramatta: "66 m³ in 2024 (Sydney Water clean-up operations)",
        harbour: "Clean-ups occur, but no comparable harbour-wide figure is published",
    },
];

export const DRONE_SPECS = [
    {
        title: "Solar-powered and self-piloting",
        detail: "Solar charging and GPS-guided routes, with inbuilt weather and pressure monitors that tell each Guardian when conditions turn, and when it is time to head home.",
    },
    {
        title: "Safe around marine life",
        detail: "AI detection separates rubbish from fish and other wildlife before collection. If something large bumps the hull, a harbour bull shark, say, pressure sensors send the Guardian straight back to its pod.",
    },
    {
        title: "Weather-linked, no-risk deployment",
        detail: "Each Guardian's GPS is connected to a live weather monitoring system. If dangerous conditions are forecast, storms, high winds or flood-rated flows, the fleet simply does not deploy, so there is no risk of vessel damage.",
    },
    {
        title: "The nightly sift",
        detail: "9:30pm to 6:30am, while the ferries are tied up. Jet propulsion covers 20+ km a night, up to 1.08 million m² of waterway, or about 756,000 m² at 70% effective collection time.",
    },
    {
        title: "100 kg contained capacity",
        detail: "A full cubic metre of internal storage, capped at 100 kg depending on the material. Everything stays inside the hull, nothing trails behind the unit.",
    },
    {
        title: "Pod stations",
        detail: "Each Guardian returns automatically to its onshore pod, which acts as dock, charger and catch storage until our crew weighs, sorts and logs the haul.",
    },
    {
        title: "Art and open data",
        detail: "Commissioned Indigenous artwork on every hull, and every night's catch published to the open Trash Ledger for anyone to inspect.",
    },
];

export const OPS_STATS = [
    { value: "9:30pm–6:30am", label: "Nightly sift, clear of ferry traffic" },
    { value: "20+ km", label: "Jet propulsion range per night" },
    { value: "100 kg / 1 m³", label: "Contained capacity per Guardian" },
    { value: "756,000 m²", label: "Nightly coverage per Guardian (70% effective collection)" },
    { value: "Automatic", label: "Return to pod for offload, charge and storage" },
];

export const SYSTEMS = [
    {
        category: "Navigation & Control",
        items: [
            {
                title: "GPS and antenna",
                detail: "The GPS tracks the Guardian's exact location and allows it to follow programmed cleaning routes, connecting to the autonomous navigation system so the unit moves through assigned areas without constant manual control.",
            },
            {
                title: "Autonomous navigation",
                detail: "The Guardian follows planned routes through the waterway and operates independently. Its location and movement can be monitored so operators can manage multiple Guardians at once.",
            },
            {
                title: "Electric propulsion",
                detail: "Electric jet propulsion moves the Guardian through the water and along its programmed route, working alongside GPS and autonomous controls to keep the unit inside its cleaning area.",
            },
            {
                title: "Weather and pressure monitors",
                detail: "Inbuilt weather and pressure monitors watch conditions around the hull, so the Guardian knows when the weather is turning, and when it should head back to the pod.",
            },
            {
                title: "Fleet monitoring",
                detail: "Multiple Guardians operate across different parts of a waterway while being monitored together, so operators see the location and performance of the entire fleet rather than controlling each machine individually.",
            },
        ],
    },
    {
        category: "Collection System",
        items: [
            {
                title: "Whale shark-inspired hull",
                detail: "The body is shaped like a whale shark, wide at the front, streamlined behind. At roughly 2.6 metres long and 1 metre wide, the design gives the Guardian a large collection area while moving efficiently through the water.",
            },
            {
                title: "Deep catchment mouth",
                detail: "The large mouth extends below the waterline, allowing the Guardian to collect rubbish that is not simply floating on the surface. The deep catchment leads directly into the internal collection system.",
            },
            {
                title: "Guide vanes",
                detail: "Inside the mouth, guide vanes direct incoming water and rubbish towards the filtration and suction components, creating a controlled path for debris as it enters the Guardian.",
            },
            {
                title: "Suction system",
                detail: "Suction ports draw smaller pieces of rubbish and microplastics into the Guardian, targeting pollution that would normally pass straight through a standard surface litter net.",
            },
            {
                title: "Fine mesh filtration",
                detail: "The fine mesh catches smaller particles and microplastics while allowing water to pass through, a second level of collection after larger rubbish has entered through the mouth.",
            },
            {
                title: "Internal pumps",
                detail: "Pumps create the controlled water movement and suction required to pull smaller particles through the filtration system, working with the mouth, guide vanes and filters to move pollution into storage.",
            },
            {
                title: "Internal waste storage",
                detail: "Collected rubbish and filtered material are stored inside the Guardian rather than left floating behind it. Once the 1 m³ storage area is full (up to 100 kg), the material is removed, weighed and sorted.",
            },
            {
                title: "Contained cleaning system",
                detail: "The entire process happens within the Guardian, from collecting debris through the mouth, to filtering smaller particles, to storing the waste. One continuous system, rather than separate machines for different types of pollution.",
            },
        ],
    },
    {
        category: "Intelligence & Safety",
        items: [
            {
                title: "Sensors and monitoring",
                detail: "Sensors record the Guardian's location, operation and cleaning activity, creating useful data on where pollution is being collected and how effectively the unit is operating.",
            },
            {
                title: "AI wildlife detection",
                detail: "An AI detection system identifies objects entering the catchment before they are collected, distinguishing rubbish from fish and other marine life, suction activates only when suitable waste is detected.",
            },
            {
                title: "Pressure bump response",
                detail: "Pressure systems detect whether a creature bumps into the Guardian, a harbour bull shark, for example, and the unit immediately returns to its onshore pod, protecting marine life and preventing further damage.",
            },
            {
                title: "Pollution data collection",
                detail: "The Guardian records how much material it collects and where. Over time this identifies pollution hotspots and helps councils understand which areas need the most attention.",
            },
            {
                title: "Environmental impact measurement",
                detail: "Because every collection is recorded, RiverGuardian reports measurable results to councils, the amount of waste removed and the areas cleaned, giving councils evidence of the return on their investment.",
            },
        ],
    },
    {
        category: "Lifecycle & Scale",
        items: [
            {
                title: "Waste sorting and recycling",
                detail: "After collection, waste is removed from the storage system and separated into material types. Recyclable plastic enters recycling streams rather than being simply disposed of.",
            },
            {
                title: "Indigenous artwork",
                detail: "Each Guardian carries Indigenous artwork on its exterior, with Indigenous artists involved in the project, connecting the technology with the cultural importance of the waterways it cleans.",
            },
            {
                title: "Marine-grade construction",
                detail: "Waterproof, corrosion-resistant construction protects the electronics, batteries, pumps and other components from constant exposure to the water.",
            },
            {
                title: "Replaceable components",
                detail: "Filters, nets, pumps and other wear parts are designed to be replaced as they wear out, making the Guardian easier to maintain and avoiding whole-machine replacement.",
            },
            {
                title: "Multi-Guardian deployment",
                detail: "The design scales from a single Guardian to a larger fleet. More units deploy as demand increases, allowing RiverGuardian to expand from one waterway into multiple rivers, harbours and coastal areas.",
            },
        ],
    },
];

export const MAP_BOUNDS = { lngMin: 150.96, lngMax: 151.33, latMin: -33.92, latMax: -33.71 };

export const SYDNEY_COUNCILS_MAP = [
    {
        id: "parramatta", name: "Parramatta", ll: [150.985, -33.8], stage: 2, highlight: true,
        note: "Year 2 contract, Burramattagal Country, where the river meets the city.",
        spots: [
            { name: "Parramatta Wharf", ll: [151.004, -33.813] },
            { name: "Charles Street Weir", ll: [150.992, -33.808] },
        ],
    },
    {
        id: "ryde", name: "Ryde", ll: [151.088, -33.806], stage: 1,
        note: "Year 1, our first contract, anchored at Meadowbank and Putney Beach.",
        spots: [
            { name: "Meadowbank", ll: [151.09, -33.815] },
            { name: "Putney Beach", ll: [151.103, -33.823] },
        ],
    },
    {
        id: "hunters-hill", name: "Hunters Hill", ll: [151.133, -33.826], stage: 3,
        note: "Year 3, the peninsula reaches of the lower river.",
        spots: [
            { name: "Hunters Hill Sailing Club", ll: [151.138, -33.834] },
            { name: "Alexandra Street Wharf", ll: [151.149, -33.841] },
        ],
    },
    {
        id: "canada-bay", name: "Canada Bay", ll: [151.1, -33.83], stage: 3,
        note: "Year 3, Wangal Country, the harbour-side reaches.",
        spots: [
            { name: "Cabarita", ll: [151.113, -33.842] },
            { name: "Bayview Park", ll: [151.1, -33.852] },
        ],
    },
    {
        id: "strathfield", name: "Strathfield", ll: [151.062, -33.862], stage: 6,
        note: "Year 6, the Homebush Bay foreshore.",
        spots: [
            { name: "Homebush Bay", ll: [151.072, -33.838] },
            { name: "Bicentennial Park", ll: [151.08, -33.847] },
        ],
    },
    {
        id: "inner-west", name: "Inner West", ll: [151.145, -33.874], stage: 3,
        note: "Year 3, Iron Cove and the inner bays.",
        spots: [
            { name: "Iron Cove", ll: [151.152, -33.86] },
            { name: "Birkenhead Point", ll: [151.163, -33.856] },
        ],
    },
    {
        id: "willoughby", name: "Willoughby", ll: [151.19, -33.785], stage: 3,
        note: "Year 3, the Middle Harbour catchment.",
        spots: [
            { name: "Northbridge", ll: [151.207, -33.793] },
            { name: "Flat Rock Gully", ll: [151.193, -33.798] },
        ],
    },
    {
        id: "ku-ring-gai", name: "Ku-ring-gai", ll: [151.205, -33.738], stage: 5,
        note: "Year 5, the upper Middle Harbour creeks.",
        spots: [
            { name: "Bantry Bay", ll: [151.222, -33.753] },
            { name: "Roseville Chase", ll: [151.196, -33.773] },
        ],
    },
    {
        id: "north-sydney", name: "North Sydney", ll: [151.198, -33.828], stage: 4,
        note: "Year 4, the northern harbour foreshore.",
        spots: [
            { name: "Balls Head", ll: [151.193, -33.843] },
            { name: "Berrys Bay", ll: [151.203, -33.841] },
        ],
    },
    {
        id: "mosman", name: "Mosman", ll: [151.245, -33.815], stage: 4,
        note: "Year 4, Balmoral and Middle Harbour.",
        spots: [
            { name: "Balmoral", ll: [151.25, -33.823] },
            { name: "Chowder Bay", ll: [151.255, -33.838] },
        ],
    },
    {
        id: "city-of-sydney", name: "City of Sydney", ll: [151.19, -33.884], stage: 4,
        note: "Year 4, harbour expansion into Gadigal waters.",
        spots: [
            { name: "Barangaroo", ll: [151.201, -33.859] },
            { name: "Blackwattle Bay", ll: [151.176, -33.868] },
        ],
    },
    {
        id: "woollahra", name: "Woollahra", ll: [151.24, -33.882], stage: 5,
        note: "Year 5, the eastern harbour bays.",
        spots: [
            { name: "Point Piper", ll: [151.246, -33.866] },
            { name: "Lady Martins Beach", ll: [151.241, -33.87] },
            { name: "Rose Bay", ll: [151.262, -33.87] },
            { name: "Vaucluse", ll: [151.274, -33.855] },
        ],
    },
    {
        id: "northern-beaches", name: "Northern Beaches", ll: [151.252, -33.762], stage: 6,
        note: "Year 6, completing the thirteen-council network, from the harbour mouth to the northern lagoons.",
        spots: [
            { name: "Manly Cove", ll: [151.284, -33.798] },
            { name: "North Harbour", ll: [151.268, -33.802] },
            { name: "Dee Why Lagoon", ll: [151.302, -33.757] },
            { name: "Narrabeen Lagoon", ll: [151.296, -33.724] },
        ],
    },
];

export const RIVER_GEO = [
    [150.995, -33.81], [151.02, -33.812], [151.045, -33.815], [151.07, -33.816],
    [151.095, -33.82], [151.115, -33.83], [151.135, -33.836], [151.15, -33.845],
    [151.165, -33.855], [151.18, -33.86], [151.195, -33.862],
];

export const MAP_STAGES = [
    { year: "Year 1", label: "Ryde" },
    { year: "Year 2", label: "+ Parramatta" },
    { year: "Year 3", label: "+ Hunters Hill · Canada Bay · Inner West · Willoughby" },
    { year: "Year 4", label: "+ City of Sydney · North Sydney · Mosman" },
    { year: "Year 5", label: "+ Woollahra · Ku-ring-gai" },
    { year: "Year 6", label: "+ Northern Beaches · Strathfield, all 13 target councils" },
];

export const PROTOTYPE_STEPS = [
    { title: "Glides through water", detail: "Low-energy autonomous navigation patrols the catchment." },
    { title: "Wide opening below surface", detail: "The submerged mouth collects larger litter as it moves." },
    { title: "Microplastics drawn in", detail: "Suction ports and fine mesh filters pull in particles and small debris." },
    { title: "Debris trapped in bin", detail: "Waste is held in an internal bin; filtered water is released back." },
];

export const PROTOTYPE_CHIPS = ["2.6 m length", "1.0 m height", "Fine-mesh microplastic net", "Solar + GPS", "Fish-safe glide", "Docking-station offload"];

export const CULTURE_POINTS = [
    {
        title: "A place of deep significance",
        detail: "The Parramatta River is far more than a waterway, it is a place of deep cultural significance for the Wallumedegal people, the Traditional Custodians of the Ryde area.",
    },
    {
        title: "Generations of connection",
        detail: "For generations the river has supported cultural practices, food gathering, travel and community for the Wallumedegal, Burramattagal and Wangal peoples, an enduring relationship between people and Country.",
    },
    {
        title: "Pollution breaks the link",
        detail: "Contamination degrades the health and character of the river, making traditional ecological knowledge and the responsibility of caring for Country harder to maintain and share.",
    },
    {
        title: "An investment in heritage",
        detail: "Protecting the river is not simply an environmental responsibility, it preserves cultural heritage, strengthens community identity, and keeps this place meaningful for generations to come.",
    },
];

export const COUNTRIES = [
    { group: "Wallumedegal", area: "Ryde and the river foreshores" },
    { group: "Burramattagal", area: "Parramatta, where the river meets the city" },
    { group: "Wangal", area: "Canada Bay and the Inner West" },
    { group: "Gadigal", area: "Sydney Harbour, Eora Nation" },
    { group: "Dharug & Eora", area: "The language groups of the wider catchment" },
];

export const RYDE_IMPACTS = [
    "$697,000+ already invested by Council in the Putney Park swimming site, on top of ongoing stormwater, monitoring and restoration spend",
    "Lost recreational and tourism value while the river stays unsuitable for swimming",
    "Billions in pollution-driven health costs borne annually across metropolitan NSW",
    "Depressed business activity and property value along degraded waterways",
];

export const FUNDING_TODAY = [
    "$697,000+ committed to patching up a single swimming site at Putney Park",
    "Ongoing stormwater, monitoring and restoration spend with no end date",
    "Litter returns with every tide, the river stays unswimmable",
    "No public data showing ratepayers what their money removed",
];

export const FUNDING_WITH_RG = [
    "The same dollars contract nightly, autonomous removal at the source",
    "Every kilogram weighed, logged and published to the open Trash Ledger",
    "Hotspots mapped over time, so spending targets the worst reaches first",
    "25% of recyclables fund Indigenous artists, culture built into the contract",
];

export const COUNCILS = [
    "Blacktown",
    "Burwood",
    "Canterbury-Bankstown",
    "Canada Bay",
    "Cumberland",
    "Inner West",
    "Hunters Hill",
    "Parramatta",
    "Ryde",
    "Strathfield",
];

export const ALL_SYDNEY_COUNCILS = [
    "Bayside",
    "Blacktown",
    "Blue Mountains",
    "Burwood",
    "Camden",
    "Campbelltown",
    "Canada Bay",
    "Canterbury-Bankstown",
    "City of Sydney",
    "Cumberland",
    "Fairfield",
    "Georges River",
    "Hawkesbury",
    "Hornsby",
    "Hunters Hill",
    "Inner West",
    "Ku-ring-gai",
    "Lane Cove",
    "Liverpool",
    "Mosman",
    "North Sydney",
    "Northern Beaches",
    "Parramatta",
    "Penrith",
    "Randwick",
    "Ryde",
    "Strathfield",
    "Sutherland Shire",
    "The Hills Shire",
    "Waverley",
    "Willoughby",
    "Woollahra",
    "Wollondilly",
];

export const ROADMAP = [
    {
        year: "Year 1",
        title: "Ryde, the Eora Guardian takes the water",
        value: "$240k per annum",
        detail: "Our first fleet, nine River Guardians of the Eora class, deploys on Wallumedegal Country at Meadowbank and Putney. Establishment investment of ~$450k builds the fleet and the servicing team.",
    },
    {
        year: "Year 2",
        title: "City of Parramatta joins",
        value: "$362k combined",
        detail: "Second council contract signed on Burramattagal Country. The fleet grows to 12 Guardians and the service turns profitable.",
    },
    {
        year: "Year 3",
        title: "Catchment expansion",
        value: "$1.40m",
        detail: "Contracts across the ten catchment councils, targeting the Toongabbie Creek hotspot, the state's #4 most contaminated waterway.",
    },
    {
        year: "Year 4",
        title: "Harbour expansion",
        value: "$2.70m",
        detail: "Operations extend into the Gadigal waters of Sydney Harbour and its tributaries, including Middle Harbour Creek (#10).",
    },
    {
        year: "Year 5",
        title: "Wider Sydney",
        value: "$4.75m",
        detail: "Metro-wide service agreements bring the fleet toward full scale across Greater Sydney's 33 councils.",
    },
    {
        year: "Year 6+",
        title: "Full Sydney coverage",
        value: "$8m per year",
        detail: "120 Guardians serviced by a lean crew of ~15, one for every two of the ~30 stations. Their job: hand the catch to recycling-company collectors when the Guardians dock, and keep every unit charging. Expansion stops, only ~12 replacement Guardians per year at ~$7,500 each.",
    },
];

const baseFinancials = [
    { year: "Y1", revenue: 0.24, profit: -0.21, cumulative: -0.21 },
    { year: "Y2", revenue: 0.362, profit: 0.173, cumulative: -0.037 },
    { year: "Y3", revenue: 1.4, profit: 0.914, cumulative: 0.877 },
    { year: "Y4", revenue: 2.7, profit: 1.79, cumulative: 2.67 },
    { year: "Y5", revenue: 4.75, profit: 3.25, cumulative: 5.92 },
    { year: "Y6", revenue: 8.0, profit: 5.66, cumulative: 11.58 },
    { year: "Y7", revenue: 8.0, profit: 5.81, cumulative: 17.39 },
    { year: "Y8", revenue: 8.0, profit: 5.81, cumulative: 23.2 },
    { year: "Y9", revenue: 8.0, profit: 5.81, cumulative: 29.01 },
    { year: "Y10", revenue: 8.0, profit: 5.81, cumulative: 34.82 },
];

const scale = (factor) =>
    baseFinancials.map((row) => ({
        year: row.year,
        revenue: +(row.revenue * factor).toFixed(3),
        profit: +(row.profit * factor).toFixed(3),
        cumulative: +(row.cumulative * factor).toFixed(3),
    }));

export const SCENARIOS = {
    conservative: {
        label: "Conservative",
        note: "Councils sign ~$4.8m/yr of mature contracts (60% of target)",
        data: scale(0.6),
        headline: "~$20.9m",
    },
    expected: {
        label: "Expected",
        note: "Councils sign ~$8m/yr of mature contracts (full Sydney coverage)",
        data: baseFinancials,
        headline: "~$34.8m",
    },
    high: {
        label: "High",
        note: "Councils sign ~$10m/yr of mature contracts (125% of target)",
        data: scale(1.25),
        headline: "~$43.5m",
    },
};

export const RECYCLING_ROWS = [
    { year: 1, collected: 75, recyclable: 45, artists: 11.25, sold: 33.75, revenue: "$14,400" },
    { year: 2, collected: 100, recyclable: 60, artists: 15, sold: 45, revenue: "$19,200" },
    { year: 3, collected: 200, recyclable: 120, artists: 30, sold: 90, revenue: "$38,500" },
    { year: 4, collected: 375, recyclable: 225, artists: 56.25, sold: 168.75, revenue: "$72,100" },
    { year: 5, collected: 625, recyclable: 375, artists: 93.75, sold: 281.25, revenue: "$120,200" },
    { year: 6, collected: 1000, recyclable: 600, artists: 150, sold: 450, revenue: "$192,400" },
    { year: 7, collected: 1000, recyclable: 600, artists: 150, sold: 450, revenue: "$192,400" },
    { year: 8, collected: 1000, recyclable: 600, artists: 150, sold: 450, revenue: "$192,400" },
    { year: 9, collected: 1000, recyclable: 600, artists: 150, sold: 450, revenue: "$192,400" },
    { year: 10, collected: 1000, recyclable: 600, artists: 150, sold: 450, revenue: "$192,400" },
];

export const WASTE_TONNES = RECYCLING_ROWS.map((row) => ({
    year: `Y${row.year}`,
    collected: row.collected,
    sold: row.sold,
}));

export const RECYCLING_TOTAL = {
    collected: "7,375 t",
    recyclable: "4,425 t",
    artists: "1,106.25 t",
    sold: "3,318.75 t",
    revenue: "~$1.23m",
};

export const MATERIAL_PRICES = [
    { material: "Mixed plastics", price: "$250/t", share: "70%" },
    { material: "Metals", price: "$1,000/t", share: "25%" },
    { material: "Glass / other", price: "$50/t", share: "5%" },
];

export const BUYERS = [
    { material: "Plastic", buyer: "Pact Group", why: "Major Australian recycled-plastics producer" },
    { material: "Steel / aluminium", buyer: "Sell & Parker", why: "Sydney scrap-metal recycler" },
    { material: "Copper / other metals", buyer: "Urban Copper Recycling", why: "Sydney metal recycling" },
    { material: "Mixed metals", buyer: "METALMAX Recyclers", why: "Sydney recycling and buy-back service" },
];

export const ORG_TYPES = [
    "Local Council",
    "State Agency",
    "Sydney Water / Utility",
    "Corporate Partner",
    "Other",
];

export const CATCHMENT_OPTIONS = [...ALL_SYDNEY_COUNCILS, "Sydney Harbour", "Other / Multiple"];
